import List from '@material-ui/core/List';
import * as React from 'react';
import Menu from './Menu';

const SidebarContent: React.FunctionComponent = () => {
    return (
        <div className="rct-sidebar-nav">
            <nav className="navigation">
                <List className="rct-mainMenu p-0 m-0 list-unstyled">
                    <Menu/>
                </List>
            </nav>
        </div>
    );
};

export default SidebarContent;
